<template>
    <div class="menu-cart-contrainer">
      <div v-if="displaySuggestion && SuggestionDetail && flagReciveOrder == 'delivery'" class="menu-cart-suggestion pb-2">
        <label class="text-subtitle" v-if="!SuggestionDetail.distanceOverFlag">
          {{ $t('suggestion.addorder') }} 
          <b class="fw-md">{{ (TotalDeliverySuggestion) | priceFormat(0,currency) }}</b> 
          {{ $t('suggestion.text1') }} 
          <em class="fw-md fs-st-n font-green">{{ $t('suggestion.deliveryFee') }}!</em>
        </label>
        <label class="text-subtitle" v-else-if="SuggestionDetail.distanceOverFlag && SuggestionDetail.freeFlag">
          {{ $t('suggestion.addorder') }} 
          <b class="fw-md">{{ (TotalDeliverySuggestion) | priceFormat(0,currency) }}</b> 
          {{ $t('suggestion.text2') }} 
          <em class="fw-md fs-st-n font-green">{{ $t('suggestion.deliveryFee') }}</em>
        </label>
        <label class="text-subtitle" v-else-if="SuggestionDetail.distanceOverFlag && !SuggestionDetail.freeFlag">
          {{ $t('suggestion.addorder') }} 
          <b class="fw-md">{{ (TotalDeliverySuggestion) | priceFormat(0,currency) }}</b> 
          {{ $t('suggestion.text2') }} 
          <em class="fw-md fs-st-n font-green">
            {{ $t('suggestion.discount') }} 
            {{ $t('suggestion.delivery') }}
            {{ SuggestionDetail.feeAmt | priceFormat(0,currency)}}
          </em>
        </label>
      </div>
      <div class="menu-cart-btn text-button">
        <el-row>
          <el-col :span="8">
            <el-badge :value="badge" class="menu-cart" type="primary">
              <!-- <i class="el-icon-shopping-cart-full" @click.native="checkoutToCart"></i> -->
              <img src="@/assets/icons/basket.png" />
              <!-- <el-button size="large" > <i class="el-icon-shopping-cart-full"></i></el-button> -->
            </el-badge>
          </el-col>
          <el-col :span="8" class="text-center cart-text">
            <b>{{ $t('pageMenuList.header.seecart') }}</b>
          </el-col>
          <el-col :span="8" class="text-right cart-price">
            <b v-if="flagReciveOrder === 'delivery'">{{ (TotalCartPrice + deliveryFee) | priceFormat(roundingType,currency) }}</b>
            <b v-else>{{ TotalCartPrice | priceFormat(roundingType,currency) }}</b>
          </el-col>
        </el-row>
      </div>
    </div>
</template>
<script>
import Mixins from '@/utils/mixins'
export default {
    name: 'MenuCartBtn',
    data () {
      return {
        orderType: true,
        deliveryFee: 0,
        coordinates: {},
        displaySuggestion: false,
        TotalDeliverySuggestion: 0,
        currentLocation: {},
        TempTotalPrice: 0,
        currency: this.$store.getters.currency
      }
    },
    props: {
      badge: {
        default: 0
      }
    },
    mixins: [Mixins],
    computed: {
      TotalCartPrice () {
        return this.$store.getters.TotalCartPrice
      },
      BranchDetail () {
        return this.$store.getters.BranchDetail
      },
      roundingType () {
        return this.$store.getters.roundingType
      },
      flagReciveOrder () {
        let flagReciveOrder = this.$store.getters.flagReciveOrder
        if (flagReciveOrder === null) {
          flagReciveOrder = JSON.parse(localStorage.getItem('send-' + this.BranchDetail.id))
        }
        return flagReciveOrder
      },
      ChangeLocation () {
        let ChangeLocation = this.$store.getters.ChangeLocation
        let receive = JSON.parse(localStorage.getItem('send-' + this.BranchDetail.id))
        if (ChangeLocation === null || this.SuggestionDetail === null || receive == 'pick-up' || this.SuggestionDetail.minimumOrderFalg && this.TotalCartPrice < this.SuggestionDetail.minimumOrderAmt) {
          this.$emit('toggle_dialog', { display: false, src: '', title: '', text: '', ChangeLocation: null })
        } else {
          let loc = JSON.parse(localStorage.getItem('fsloc'))
          if (this.SuggestionDetail.distance > 0 && this.SuggestionDetail.feeAmt == 0 || this.SuggestionDetail.totalFree == 0) {
            this.$emit('toggle_dialog', {
              display: (loc.new == 1) ? true : false,
              src: 'icons/complete-suggestion.png',
              title: this.$t('suggestion.congrate') + ' <br> <label class="font-green">' + this.$t('suggestion.text2') +' '+ this.$t('suggestion.deliveryFee') + '</label>',
              text: '',
              ChangeLocation: ChangeLocation
            })
            this.displaySuggestion = false
          } else if (this.SuggestionDetail.distance == 0 && this.SuggestionDetail.feeAmt == 0 || this.SuggestionDetail.totalFree == 0) {
            if (this.TotalCartPrice >= this.SuggestionDetail.totalFree) {
              this.$emit('toggle_dialog', {
                display: (loc.new == 1) ? true : false,
                src: 'icons/complete-suggestion.png',
                title: this.$t('suggestion.congrate') + ' <br> <label class="font-green">' + this.$t('suggestion.text2') +' '+ this.$t('suggestion.deliveryFee') + '</label>',
                text: '',
                ChangeLocation: ChangeLocation
              })
              this.displaySuggestion = false
            } else {
              if (this.SuggestionDetail.overDetail.normalDeliveryFee == 0) {
                this.$emit('toggle_dialog', {
                  display: (loc.new == 1) ? true : false,
                  src: 'icons/complete-suggestion.png',
                  title: this.$t('suggestion.congrate') + ' <br> <label class="font-green">'+ this.$t('suggestion.text2') +' '+ this.$t('suggestion.deliveryFee') + '</label>',
                  text: '',
                  ChangeLocation: ChangeLocation
                })
                this.displaySuggestion = false
              } else {
                this.$emit('toggle_dialog', {
                  display: (loc.new == 1) ? true : false,
                  src: 'icons/driver-delivery.png',
                  title: `(${this.$t('suggestion.promotion')} ${this.$t('suggestion.order')} ${this.price_format(this.SuggestionDetail.totalFree,this.currency)} <br> ${this.$t('suggestion.savedeliveryfee')})`,
                  text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                  ChangeLocation: ChangeLocation
                })
                this.TotalDeliverySuggestion = this.SuggestionDetail.totalFree - this.TotalCartPrice
                this.displaySuggestion = true
              }
            }
          } else {
            if (this.TotalCartPrice >= this.SuggestionDetail.totalFree) {
              if (this.SuggestionDetail.distanceOverFlag) {
                if (this.SuggestionDetail.freeFlag) {
                  this.$emit('toggle_dialog', {
                    display: (loc.new == 1) ? true : false,
                    src: 'icons/complete-suggestion.png',
                    title: `${this.$t('suggestion.congrate')} <br> <label class="font-green"> ${this.$t('suggestion.text1')} ${this.$t('suggestion.deliveryFee')} </label>`,
                    text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                    ChangeLocation: ChangeLocation
                  })
                } else {
                  this.$emit('toggle_dialog', {
                    display: (loc.new == 1) ? true : false,
                    src: 'icons/complete-suggestion.png',
                    title: `${this.$t('suggestion.congrate')} <br> <label class="font-green"> ${this.$t('suggestion.yourdiscount')} ${this.$t('suggestion.delivery')} ${this.price_format(this.SuggestionDetail.feeAmt,this.currency)} </label>`,
                    text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)}})`,
                    ChangeLocation: ChangeLocation
                  })
                }
              } else {
                this.$emit('toggle_dialog', {
                  display: (loc.new == 1) ? true : false,
                  src: 'icons/complete-suggestion.png',
                  title: `${this.$t('suggestion.congrate')} <br> <label class="font-green"> ${this.$t('suggestion.text1')} ${this.$t('suggestion.deliveryFee')} </label>`,
                  text: (this.SuggestionDetail.feeAmt == 0) ? '' : `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                  ChangeLocation: ChangeLocation
                })
              }
              this.TotalDeliverySuggestion = 0
              this.displaySuggestion = false
            } else {
              this.TotalDeliverySuggestion = this.SuggestionDetail.totalFree - this.TotalCartPrice
              if (this.SuggestionDetail.distanceOverFlag) {
                if (this.SuggestionDetail.freeFlag) {
                  this.$emit('toggle_dialog', {
                    display: (loc.new == 1) ? true : false,
                    src: 'icons/driver-delivery.png',
                    title: `${this.$t('suggestion.promotion')} ${this.$t('suggestion.order')} ${this.price_format(this.SuggestionDetail.totalFree,this.currency)} <br> ${this.$t('suggestion.savedeliveryfee')}`,
                    text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                    ChangeLocation: ChangeLocation
                  })
                } else {
                  this.$emit('toggle_dialog', {
                    display: (loc.new == 1) ? true : false,
                    src: 'icons/driver-delivery.png',
                    title: `${this.$t('suggestion.promotion')} ${this.$t('suggestion.order')} ${this.price_format(this.SuggestionDetail.totalFree,this.currency)} <br> ${this.$t('suggestion.reciveDiscount')} ${this.$t('suggestion.delivery')} ${ this.currency } ${this.SuggestionDetail.feeAmt}`,
                    text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                    ChangeLocation: ChangeLocation
                  })
                }
              } else {
                this.$emit('toggle_dialog', {
                  display: (loc.new == 1) ? true : false,
                  src: 'icons/driver-delivery.png',
                  title: `${this.$t('suggestion.promotion')} ${this.$t('suggestion.order')} ${this.price_format(this.SuggestionDetail.totalFree,this.currency)} <br> ${this.$t('suggestion.savedeliveryfee')}`,
                  text: `(${this.$t('suggestion.normaldeliveryfee')} ${this.price_format(this.SuggestionDetail.overDetail.normalDeliveryFee,this.currency)})`,
                  ChangeLocation: ChangeLocation
                })
              }
              this.displaySuggestion = true
            }
          }
        }
        return ChangeLocation
      },
      SuggestionDetail () {
        return this.$store.getters.SuggestionDetail
      }
    },
    watch: {
      ChangeLocation () {},
      SuggestionDetail () {}
    }
}
</script>


// WEBPACK FOOTER //
// src/components/menu/MenuCartBtn.vue